import { Box, Typography } from "@material-ui/core"
import React from "react"

type HeaderType = "heading" | "subheading"

export interface Props {
  type: HeaderType
  name: string
  description?: string
}

const Header: React.FC<Props> = ({ type, name, description }) => {
  const variant = type === "heading" ? "h3" : "h4"
  const subVariant = type === "heading" ? "subtitle1" : "subtitle2"

  return (
    <Box mt={3}>
      <Typography variant={variant}>{name}</Typography>
      {description && (
        <Typography variant={subVariant}>{description}</Typography>
      )}
    </Box>
  )
}

export default Header
